import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { ConfirmPayComponent } from '../confirm-pay/confirm-pay.component';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {

  private static readonly STORAGE_KEY = 'redsys_pending_order_id';

  constructor(private dialog: MatDialog, private router: Router, private auth: AuthenticationService,
    private shoppingCartService: ShoppingCartService) {}

  ngOnInit(): void {
    // El order.id real de Laravel se guardó en localStorage antes de redirigir a Redsys.
    // La URL de retorno solo trae id_cart/Ds_Order, que no sirve para los endpoints del diálogo.
    const orderId = localStorage.getItem(PaymentSuccessComponent.STORAGE_KEY);
    localStorage.removeItem(PaymentSuccessComponent.STORAGE_KEY);

    // Vaciar el carrito tras el pago correcto
    this.shoppingCartService.setModifyCart(true);

    // Sin AuthGuard a propósito: Redsys puede devolver al usuario a un dominio
    // donde no tiene la sesión abierta (citylok.com en vez de www). El guard lo
    // mandaba al login sin decirle nada, y el pago ya está hecho. La sesión se
    // comprueba igual que en el guard, pero sin echarle.
    if (!localStorage.getItem('jwt_token')) {
      this.showWithoutSession();
      return;
    }
    this.auth.getUsersMe().subscribe({
      next: (res) => res?.success ? this.showWithSession(orderId) : this.showWithoutSession(),
      error: () => this.showWithoutSession()
    });
  }

  private showWithSession(orderId: string | null) {
    // Redirigir "por debajo" a Mis pedidos para no dejar visible la página de éxito en blanco
    const profile = this.auth.getProfile();
    const url = profile?.roleFunctions?.length > 0 ? '/panel-control/orders/list' : '/profile';
    this.router.navigate([url]);

    // Y mostrar el diálogo de descarga/WhatsApp inmediatamente, por encima del perfil
    if (orderId) {
      this.dialog.open(ConfirmPayComponent, {
        panelClass: 'info-dialog',
        disableClose: true,
        data: { idOrder: orderId }
      });
    } else {
      // Sin id no podemos abrir el diálogo; el pago ya se hizo (estamos en la URL de éxito)
      this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: false,
          text: 'El pago se ha realizado correctamente. Podrás consultar las entradas en tu correo electrónico o en el apartado Mis compras de tu perfil.',
          btnCancel: false
        }
      });
    }
  }

  /**
   * Sin sesión no se pueden descargar las entradas (el diálogo de descarga va
   * autenticado), pero sí confirmar el pago: es lo que evita que el usuario
   * crea que ha fallado y vuelva a comprar.
   */
  private showWithoutSession() {
    this.router.navigate(['/']);
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: 'El pago se ha realizado correctamente. Recibirás las entradas en tu correo electrónico. También puedes consultarlas iniciando sesión, en el apartado Mis compras de tu perfil.',
        btnCancel: false
      }
    });
  }
}
